const mfaCodeEntryPage = app => `/mfa`;
const resetPasswordPage = app => `reset-password`;
const loginPage = app => `/login/${app}`;

module.exports = {
  mfaCodeEntryPage,
  resetPasswordPage,
  loginPage
};